module.exports = __webpack_public_path__ + "img/icb-del-Inte-m@2x.920036e0.png";